import { experiments } from '../experiments';

export const isAnonymousAiChatbotEnabled = (): boolean => experiments.is('enableAnonymousAIChatbot', 'B');
